//@ts-nocheck
import React from 'react';
import { MapPin, PersonStanding } from 'lucide-react';
import { Ticket } from '@/types';
import { PriorityBadge, StatusBadge } from '@/helpers/enumStylers';
import { formatDate } from '@/helpers/formatDate';
import { Button } from '../ui/button';

interface TicketListItemProps {
  ticket: Ticket;
  selected?: boolean;
  onClick?: () => void;
  viewDetails?: boolean;
}

const TicketListItem: React.FC<TicketListItemProps> = React.memo(
  ({ ticket, selected, onClick, viewDetails }) => {
    return (
      <div
        className={`p-4 border-b cursor-pointer transition-colors duration-200 ${
          selected
            ? 'bg-accent border-l-4 border-l-secondary'
            : 'hover:bg-accent'
        }`}
        onClick={onClick}
      >
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
          <div className="flex items-center justify-between gap-2 w-full">
            <span className="font-medium text-foreground text-sm">
              {ticket.ticketNumber}
            </span>

            <div className="flex items-center gap-2 shrink-0">
              <StatusBadge status={ticket.status} size="sm" />
              <PriorityBadge priority={ticket.priority} size="sm" />
            </div>
          </div>
          {viewDetails && (
            <Button
              variant="ghost"
              size="sm"
              className="h-6 px-2 text-xs self-start sm:self-center"
            >
              View Details
            </Button>
          )}
        </div>
        <p className="text-xs text-foreground mb-2 line-clamp-2 leading-relaxed">
          {ticket.description || <i>No description provided</i>}
        </p>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-foreground w-full">
          <div className="flex items-center gap-1 min-w-0">
            <MapPin className="h-3 w-3 flex-shrink-0 text-muted-foreground" />
            <span className="truncate">
              {ticket.address1
                ? `${ticket.address1}, ${ticket.city || ''}`
                : `${Number(ticket.latitude).toFixed(5)}, ${Number(
                    ticket.longitude,
                  ).toFixed(5)}`}
            </span>
          </div>
          <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0">
            Started: {formatDate(ticket.createdAt)}
          </span>
        </div>
      </div>
    );
  },
);

export default TicketListItem;
